import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import type { AdCampaignPureUpdateMutationInput } from '@shared/api/graphql/generated';
import type { AdCampaignType } from '../api/useAdCampaign';

export const serializeAdCampaignSettings = (
  campaign: AdCampaignType,
  includePoints: boolean,
  pointIds?: readonly string[]
): AdCampaignPureUpdateMutationInput => ({
  adCompanyId: campaign.id,
  startCompany: campaign.timingSettings.startDate,
  endCompany: campaign.timingSettings.endDate,
  startDayTime: campaign.timingSettings.dayStartTime,
  endDayTime: campaign.timingSettings.dayEndTime,
  infinitely: campaign.infinitely,
  interval: campaign.interval,
  period: campaign.period,
  prevMediafileRequired: campaign.prevMediafileRequired,
  title: campaign.title,
  type: campaign.type,
  days: DateUtils.getWeekDays(campaign.timingSettings.weekdays),
  ...(includePoints ? { pointIds: pointIds ? [...pointIds] : campaign.points.map(({ id }) => id) } : {}),
});
